import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-niit',
  templateUrl: './niit.component.html',
  styleUrls: ['./niit.component.css']
})
export class NiitComponent implements OnInit {
  step = -1;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  
  constructor() { }

  ngOnInit() {
  }

}
